import types from "@/pages/product/router/router-types";

export const PRODUCT_ROUTES = [
  {
    name: "产品",
    path: "product.html",
    children: [...Object.values(types)],
  },
];
